import React, { Component } from 'react';

import './EcranVeille.css';

//----------------------------------------------------------------------------


class EcranVeille extends Component {


    constructor(props) {

        super(props);
          
    }

    componentDidMount() 
    {

    }

    componentWillUnmount()
    {

    }

    render() {

        const { onClick, appVersion } = this.props;
        /* webkit-playsinline="webkit-playsinline" */

        return (            
            <div className='EcranVeille' onClick={onClick} >
                <video src="videos/Veille.mp4" playsInline="playsInline" autoPlay="autoPlay" mute="mute" loop="loop"/>
                <div className="version">Version : { appVersion }</div>
            </div>
        );    
  }
}

//----------------------------------------------------------------------------

export default EcranVeille;



// WEBPACK FOOTER //
// ./src/EcranVeille.js